import { axiosRequest } from '@/util/axios-request'
const method = 'get'
const orgInfoUrl = '/web/organization/info'
const depListUrl = '/web/organization/departmentList'
const createFnUrl = '/web/organization/createDepartment'
const delFnUrl = '/web/organization/deldepartment'
const editFnUrl = '/web/organization/editDepartment'
const updateStaffDepartmentUrl = '/web/staff/updateStaffDepartment'
const depInfo = '/web/Organization/departmentInfo'
const depList = '/web/organization/departmentAllList'
const sortSave = '/web/organization/savedeptsort'

// 组织信息
export const orgInfoFn = () => axiosRequest({ url: orgInfoUrl, method })

// 部门列表
export const depListFn = params => axiosRequest({ url: depListUrl, method, params })

// 部门创建
export const createFn = data => axiosRequest({ url: createFnUrl, data })

// 部门删除
export const delFn = data => axiosRequest({ url: delFnUrl, data })

// 部门编辑
export const editFn = data => axiosRequest({ url: editFnUrl, data })

// 员工批量设置部门信息
export const updateStaffDepartmentFn = data => axiosRequest({ url: updateStaffDepartmentUrl, data })

// 部门信息
export const depInfoFn = params => axiosRequest({ url: depInfo, method, params })

// 部门列表
export const getDepList = params => axiosRequest({ url: depList, method, params })

// 部门列表
export const saveDepSort = params => axiosRequest({ url: sortSave, data: params })
